import _implicitStylesheets from "./reviews.css";
import _implicitScopedStylesheets from "./reviews.scoped.css?scoped=true";
import _wdsSpinner from "wds/spinner";
import _listingReviewsEmptyState from "listing/reviewsEmptyState";
import _listingReviewsErrorState from "listing/reviewsErrorState";
import _wdsChip from "wds/chip";
import _aceFilterPanel from "ace/filterPanel";
import _wdsButton from "wds/button";
import _wdsRatingSummary from "wds/ratingSummary";
import _wdsStarRatings from "wds/starRatings";
import _wdsPopover from "wds/popover";
import _listingWriteReview from "listing/writeReview";
import _listingReview from "listing/review";
import _wdsRadioGroup from "wds/radioGroup";
import _wdsMessageBox from "wds/messageBox";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div data-scroll-to="reviews"${"a0:data-dummy"}${3}></div>`;
const $fragment2 = parseFragment`<div class="backdrop${0}"${2}></div>`;
const $fragment3 = parseFragment`<div type-style="display-2"${3}><b class="average-rating${0}"${2}>${"t2"}</b></div>`;
const $fragment4 = parseFragment`<div type-style="display-2"${3}><b class="average-rating${0}"${2}>${"t2"}</b></div>`;
const $fragment5 = parseFragment`<h6 type-style="display-7"${3}>${"t1"}</h6>`;
const $fragment6 = parseFragment`<div class="write-review-popover-content${0}"${2}><span type-style="body-3"${3}>${"t2"}</span></div>`;
const $fragment7 = parseFragment`<div class="review-header-container review-header-item${0}"${2}><h6 type-style="display-7" data-testid="single-review-headline"${3}>${"t2"}</h6></div>`;
const $fragment8 = parseFragment`<h6 type-style="display-7" data-testid="reviews-headline"${3}>${"t1"}</h6>`;
const $fragment9 = parseFragment`<span type-style="body-3" class="sort-label${0}"${2}>${"t1"}</span>`;
const $fragment10 = parseFragment`<span${3}>${"t1"}</span>`;
const stc0 = {
  key: 0
};
const stc1 = {
  "reviews-container": true
};
const stc2 = {
  classMap: {
    "filters": true
  },
  attrs: {
    "size": "3:12"
  },
  key: 6
};
const stc3 = {
  classMap: {
    "filter-chips": true,
    "mobile-filter-chips": true
  },
  key: 7
};
const stc4 = {
  "filter-panel": true
};
const stc5 = {
  "close-button": true
};
const stc6 = {
  "data-testid": "closeButton"
};
const stc7 = {
  classMap: {
    "reviews": true
  },
  attrs: {
    "size": "12:12@x-small 9:12@large"
  },
  key: 14
};
const stc8 = {
  attrs: {
    "data-testid": "review-header-container"
  },
  key: 15
};
const stc9 = {
  classMap: {
    "review-header-container": true
  },
  key: 16
};
const stc10 = {
  classMap: {
    "rating-summary": true
  },
  key: 17
};
const stc11 = {
  slotAssignment: "label",
  attrs: {
    "aria-hidden": "true"
  },
  key: 21
};
const stc12 = {
  classMap: {
    "rating-summary": true
  },
  key: 22
};
const stc13 = {
  slotAssignment: "label",
  classMap: {
    "label": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 25
};
const stc14 = {
  classMap: {
    "rating-summary": true
  },
  key: 26
};
const stc15 = {
  classMap: {
    "write-review-container": true
  },
  key: 30
};
const stc16 = {
  "write-review-button": true,
  "popover-trigger": true
};
const stc17 = {
  "data-testid": "write-review-button"
};
const stc18 = {
  classMap: {
    "selected-review": true
  },
  attrs: {
    "data-scroll-to": "selected-review"
  },
  key: 38
};
const stc19 = {
  classMap: {
    "review-header-container": true,
    "review-header-item": true
  },
  key: 40
};
const stc20 = {
  classMap: {
    "button-container": true
  },
  key: 43
};
const stc21 = {
  "add-filter-button": true
};
const stc22 = {
  "data-testid": "open-filters-button"
};
const stc23 = {
  classMap: {
    "sort-button-container": true
  },
  key: 45
};
const stc24 = {
  "popover-trigger": true
};
const stc25 = {
  "data-id": "sortButton",
  "data-testid": "sortButton"
};
const stc26 = {
  classMap: {
    "sort-popover-content": true
  },
  key: 48
};
const stc27 = {
  "data-id": "sortOptions",
  "data-testid": "sortOptions"
};
const stc28 = {
  key: 52
};
const stc29 = {
  classMap: {
    "filter-chips": true
  },
  key: 55
};
const stc30 = {
  key: 58
};
const stc31 = {
  classMap: {
    "show-more-container": true
  },
  key: 62
};
const stc32 = {
  "data-testid": "showMoreButton"
};
const stc33 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, sp: api_static_part, st: api_static_fragment, k: api_key, b: api_bind, h: api_element, i: api_iterator, gid: api_scoped_id, d: api_dynamic_text, t: api_text, f: api_flatten} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16, _m17, _m18, _m19, _m20, _m21, _m22} = $ctx;
  return [$cmp.firstTime ? api_custom_element("wds-spinner", _wdsSpinner, stc0) : null, !$cmp.firstTime ? api_static_fragment($fragment1, 2, [api_static_part(0, {
    attrs: {
      "data-dummy": $cmp.scrollToParam
    }
  }, null)]) : null, !$cmp.firstTime ? $cmp.showEmptyState ? api_custom_element("listing-reviews-empty-state", _listingReviewsEmptyState, {
    props: {
      "listingId": $cmp.reviewSummary.listingId,
      "labels": $cmp.reviewEmptyLabels
    },
    key: 3
  }) : null : null, !$cmp.firstTime ? !$cmp.showEmptyState ? $cmp.hasListingReviewsError ? api_custom_element("listing-reviews-error-state", _listingReviewsErrorState, {
    props: {
      "listingId": $cmp.reviewSummary.listingId
    },
    key: 4
  }) : null : null : null, !$cmp.firstTime ? !$cmp.showEmptyState ? !$cmp.hasListingReviewsError ? api_element("div", {
    classMap: stc1,
    attrs: {
      "grid": "",
      "align-items": "spread",
      "gap": $cmp.contentGap
    },
    key: 5
  }, [$cmp.shouldDisplayFilters ? api_element("div", stc2, [$cmp.mobileFilterChips ? api_element("ul", stc3, api_iterator($cmp.filterChips, function (filterChip) {
    return api_element("li", {
      key: api_key(8, filterChip.value)
    }, [api_custom_element("wds-chip", _wdsChip, {
      props: {
        "chip": filterChip
      },
      key: 9,
      on: {
        "close": _m0 || ($ctx._m0 = api_bind($cmp.handleChipClose))
      }
    })]);
  })) : null, api_custom_element("ace-filter-panel", _aceFilterPanel, {
    classMap: stc4,
    props: {
      "options": $cmp.filters,
      "id": api_scoped_id("filters-panel")
    },
    key: 10,
    on: {
      "filterchange": _m1 || ($ctx._m1 = api_bind($cmp.handleFilterChange)),
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleFilterPanelKeyboardEvent))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc5,
    attrs: stc6,
    props: {
      "variant": "secondary",
      "name": "mobileFiltersButton",
      "disabled": $cmp.isFiltering,
      "label": $cmp.closeButtonText,
      "width": "fill"
    },
    key: 11,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.switchMobileFilterPanel)),
      "keydown": _m4 || ($ctx._m4 = api_bind($cmp.handleFilterPanelCloseButtonKeyboardEvent))
    }
  })]) : null, $cmp.shouldDisplayFilters ? $cmp.mobileFilterPanel ? api_static_fragment($fragment2, 13, [api_static_part(0, {
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.switchMobileFilterPanel))
    }
  }, null)]) : null : null, api_element("div", stc7, api_flatten([api_element("div", stc8, [api_element("div", stc9, [!$cmp.isMobilePhone ? api_element("div", stc10, [api_static_fragment($fragment3, 19, [api_static_part(2, null, api_dynamic_text($cmp.averageRating))]), api_custom_element("wds-rating-summary", _wdsRatingSummary, {
    props: {
      "averageRating": $cmp.averageRating,
      "reviewsCount": $cmp.totalReviewsCount,
      "labelPosition": $cmp.ratingReviewSummaryLabelPosition
    },
    key: 20
  }, [api_element("span", stc11, [api_text(api_dynamic_text($cmp.ratingSummaryLabel))])])]) : null, $cmp.isMobilePhone ? api_element("div", stc12, [api_static_fragment($fragment4, 24, [api_static_part(2, null, api_dynamic_text($cmp.averageRating))]), api_element("span", stc13, [api_text(api_dynamic_text($cmp.reviewsLabels.reviewsRating))])]) : null, $cmp.isMobilePhone ? api_element("div", stc14, [api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "value": $cmp.averageRating,
      "readOnly": true,
      "size": "medium",
      "labelPosition": "bottom"
    },
    key: 27
  }), api_static_fragment($fragment5, 29, [api_static_part(1, null, api_dynamic_text($cmp.totalReviews))])]) : null, api_element("div", stc15, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc16,
    attrs: stc17,
    props: {
      "variant": "primary",
      "label": $cmp.writeButtonLabel
    },
    key: 31,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.toggleWriteReviewPopover))
    }
  }), $cmp.isNewUser ? api_custom_element("wds-popover", _wdsPopover, {
    props: {
      "show": $cmp.displayWriteReviewPopover,
      "ariaLabel": $cmp.writeButtonLabel,
      "popoverOrientation": $cmp.popoverOrientation
    },
    key: 32,
    on: {
      "keydown": _m8 || ($ctx._m8 = api_bind($cmp.handleWriteReviewPopoverKeyboardEvent)),
      "close": _m9 || ($ctx._m9 = api_bind($cmp.closeWriteReviewPopover))
    }
  }, [api_static_fragment($fragment6, 34, [api_static_part(2, null, api_dynamic_text($cmp.reviewsLabels.newUserMessage))])]) : null]), $cmp.showWriteReviewModal ? api_custom_element("listing-write-review", _listingWriteReview, {
    props: {
      "listingId": $cmp.reviewSummary.listingId,
      "closedFocusTarget": $cmp.writeReviewButtonRef,
      "autoFocusOff": $cmp.shouldAutoFocusWriteReviewModal
    },
    key: 35,
    on: {
      "close": _m10 || ($ctx._m10 = api_bind($cmp.closeReviewModal))
    }
  }) : null]), $cmp.showSingleReview ? api_static_fragment($fragment7, 37, [api_static_part(2, null, api_dynamic_text($cmp.reviewerName))]) : null, $cmp.showSingleReview ? api_element("div", stc18, [api_custom_element("listing-review", _listingReview, {
    props: {
      "review": $cmp.singleReview,
      "isMobile": $cmp.isMobilePhone,
      "isSingleReview": true
    },
    key: 39,
    on: {
      "like": _m11 || ($ctx._m11 = api_bind($cmp.likeReview)),
      "unlike": _m12 || ($ctx._m12 = api_bind($cmp.unlikeReview))
    }
  })]) : null, api_element("div", stc19, [api_static_fragment($fragment8, 42, [api_static_part(1, null, api_dynamic_text($cmp.reviewCountLabel))]), api_element("div", stc20, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc21,
    attrs: stc22,
    props: {
      "variant": $cmp.buttonVariant,
      "name": "applyFilters",
      "label": $cmp.addFilterButtonText,
      "width": "fill"
    },
    key: 44,
    on: {
      "click": _m13 || ($ctx._m13 = api_bind($cmp.switchMobileFilterPanel))
    }
  }), api_element("div", stc23, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc24,
    attrs: stc25,
    props: {
      "variant": $cmp.buttonVariant,
      "name": "sortButton",
      "label": $cmp.sortButtonLabel,
      "icon": "sort"
    },
    key: 46,
    on: {
      "click": _m14 || ($ctx._m14 = api_bind($cmp.toggleTooltip))
    }
  }), api_custom_element("wds-popover", _wdsPopover, {
    props: {
      "show": $cmp.displayTooltip,
      "ariaLabel": $cmp.sortButtonLabel,
      "popoverOrientation": $cmp.popoverOrientation
    },
    key: 47,
    on: {
      "keydown": _m15 || ($ctx._m15 = api_bind($cmp.handleTooltipKeyboardEvent)),
      "close": _m16 || ($ctx._m16 = api_bind($cmp.closePopover))
    }
  }, [api_element("div", stc26, [api_static_fragment($fragment9, 50, [api_static_part(1, null, api_dynamic_text($cmp.reviewsLabels.sort.tooltip))]), api_custom_element("wds-radio-group", _wdsRadioGroup, {
    attrs: stc27,
    props: {
      "value": $cmp.sortValue,
      "options": $cmp.sortOptions,
      "multiple": "false"
    },
    key: 51,
    on: {
      "change": _m17 || ($ctx._m17 = api_bind($cmp.handleSortSelectionChange))
    }
  })])])])])])]), $cmp.showFilterChips ? api_element("div", stc28, [$cmp.desktopFilterChips ? api_static_fragment($fragment10, 54, [api_static_part(1, null, api_dynamic_text($cmp.reviewsLabels.filteredBy))]) : null, $cmp.desktopFilterChips ? api_element("ul", stc29, api_iterator($cmp.filterChips, function (filterChip) {
    return api_element("li", {
      key: api_key(56, filterChip.value)
    }, [api_custom_element("wds-chip", _wdsChip, {
      props: {
        "chip": filterChip
      },
      key: 57,
      on: {
        "close": _m18 || ($ctx._m18 = api_bind($cmp.handleChipClose))
      }
    })]);
  })) : null]) : null, $cmp.filteringOrSorting ? $cmp.isDesktopOrSorting ? api_custom_element("wds-spinner", _wdsSpinner, stc30) : null : null, !$cmp.filteringOrSorting ? api_flatten([$cmp.showEmptyFilteredReviews ? api_custom_element("listing-reviews-empty-state", _listingReviewsEmptyState, {
    props: {
      "labels": $cmp.reviewEmptyLabels,
      "filtersApplied": true
    },
    key: 59
  }) : null, !$cmp.showEmptyFilteredReviews ? api_flatten([api_iterator($cmp.listingReviews.reviews, function (review) {
    return api_custom_element("listing-review", _listingReview, {
      props: {
        "review": review,
        "isMobile": $cmp.isMobilePhone
      },
      key: api_key(60, review.id),
      on: {
        "like": _m19 || ($ctx._m19 = api_bind($cmp.likeReview)),
        "unlike": _m20 || ($ctx._m20 = api_bind($cmp.unlikeReview)),
        "showreview": _m21 || ($ctx._m21 = api_bind($cmp.navigateSingleReviewURL))
      }
    });
  }), $cmp.moreReviewsButton.show ? $cmp.loadMoreError ? api_custom_element("wds-message-box", _wdsMessageBox, {
    props: {
      "type": "error",
      "message": $cmp.loadMoreError,
      "hideCloseButton": true
    },
    key: 61
  }) : null : null, $cmp.moreReviewsButton.show ? api_element("div", stc31, [api_custom_element("wds-button", _wdsButton, {
    attrs: stc32,
    props: {
      "variant": "secondary",
      "disabled": $cmp.moreReviewsButton.disabled,
      "label": $cmp.moreReviewsButton.label
    },
    key: 63,
    on: {
      "click": _m22 || ($ctx._m22 = api_bind($cmp.handleLoadMore))
    }
  })]) : null]) : stc33]) : stc33]))]) : null : null : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1sunj95neeb";
tmpl.legacyStylesheetToken = "undefined-_reviews";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
